import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { FaGlobe, FaLaptopCode, FaChartLine } from 'react-icons/fa';

const FeatureContainer = styled.section`
  padding: 5rem 0;
  background-color: ${props => props.theme.colors.lightGray};
`;

const FeatureContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.md};
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background-color: ${props => props.theme.colors.primary};
  }
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  
  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const FeatureCard = styled.div`
  background-color: white;
  border-radius: ${props => props.theme.borderRadius.medium};
  padding: 2rem;
  box-shadow: ${props => props.theme.shadows.medium};
  transition: transform ${props => props.theme.transitions.medium};
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const FeatureIcon = styled.div`
  font-size: 3rem;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1.5rem;
`;

const FeatureTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
`;

const FeatureDescription = styled.p`
  color: ${props => props.theme.colors.lightText};
  line-height: 1.6;
`;

const FeatureSection = () => {
  const { t } = useTranslation();
  
  const features = [
    {
      icon: <FaLaptopCode />,
      title: t('services.customSoftware.title'),
      description: t('services.customSoftware.content')
    },
    {
      icon: <FaGlobe />,
      title: t('services.crossBorder.title'),
      description: t('services.crossBorder.content')
    },
    {
      icon: <FaChartLine />,
      title: t('services.digital.title'),
      description: t('services.digital.content')
    }
  ];
  
  return (
    <FeatureContainer>
      <FeatureContent>
        <SectionTitle>{t('home.features')}</SectionTitle>
        <FeatureGrid>
          {features.map((feature, index) => (
            <FeatureCard key={index}>
              <FeatureIcon>{feature.icon}</FeatureIcon>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>
                {feature.description.length > 150 
                  ? `${feature.description.substring(0, 150)}...` 
                  : feature.description}
              </FeatureDescription>
            </FeatureCard>
          ))}
        </FeatureGrid>
      </FeatureContent>
    </FeatureContainer>
  );
};

export default FeatureSection;